import axiosInstance from '../api/axiosInstance';
import { API_ENDPOINTS } from '../api/config';

export interface WalletTransaction {
  id: number;
  amount: number;            // positive = credit, negative = debit
  balance_after: number;
  transaction_type: 'refund' | 'debit' | 'credit';
  reference_type?: string;
  reference_id?: string;
  description?: string;
  created_at: string;
}

export interface Wallet {
  balance: number;
  currency: string;
  transactions: WalletTransaction[];
}

export const walletService = {
  async getWallet(): Promise<Wallet> {
    const res = await axiosInstance.get(API_ENDPOINTS.payments.wallet);
    // balance/amount come back as strings from DRF DecimalField — coerce to number.
    const d = res.data || {};
    return {
      balance: Number(d.balance ?? 0),
      currency: d.currency || 'INR',
      transactions: (d.transactions || []).map((t: any) => ({
        ...t,
        amount: Number(t.amount),
        balance_after: Number(t.balance_after),
      })),
    };
  },
};

export default walletService;
